<template>
  <div id="contenedor-obras-picker">
    <v-autocomplete
      v-model="obrasSeleccionadas"
      :label="getLabel"
      :items="getObras"
      return-object
      :multiple="multiSelect"
      filled
      clearable
      color="#6A83B5"
      background-color="#F2F6FF"
      item-text="clave"
      :filter="filtro"
      :search-input.sync="search"
      @change="enviarSeleccionados">
      <template
        v-slot:item="data">
        <v-list-item-avatar>
          <v-avatar
            size="24"
            :color="data.item.tipo.color">
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ data.item.clave }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ data.item.meta.slice(0,150) }}...
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import OBRAS from '@/graphql/querys/administracion/planeacion/obras.gql';

export default {
  name: 'ObrasPicker',
  data() {
    return {
      obrasSeleccionadas: [],
      search: '',
    };
  },
  props: {
    obrasContratos: {
      type: Array,
      required: false,
    },
    multiSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    filtro(item, queryText) {
      const clave = item.clave.toLowerCase();
      const meta = item.meta.toLowerCase();

      const expt = new RegExp(queryText, 'gi');

      return expt.test(clave) || expt.test(meta);
    },
    enviarSeleccionados() {
      // V-MODEL
      this.$emit('input', this.obrasSeleccionadas);
      // ENVIAR SOLO IDS SELECCIONADOS
      if (this.multiSelect === true) {
        this.$emit('solo-ids', this.obrasSeleccionadas.map((obra) => obra.id));
      } else if (this.obrasSeleccionadas !== null) {
        this.$emit('solo-ids', [this.obrasSeleccionadas.id]);
      } else {
        this.$emit('solo-ids', []);
      }
    },
  },
  apollo: {
    obras: {
      query: OBRAS,
    },
  },
  computed: {
    getLabel() {
      if (this.multiSelect === true) return 'Seleccionar obra(s)';
      return 'Seleccionar obra';
    },
    getObras() {
      if (!this.obras) return [];
      return this.obras
        .filter((obra) => this.obrasContratos.includes(obra.id) === false)
        .map((obra) => ({
          id: obra.id,
          ejercicio: obra.ejercicio,
          clave: obra.clave,
          tipo: obra.tipo,
          meta: obra.meta,
          programa: obra.programa,
        }));
    },
  },
  watch: {
    obrasSeleccionadas() {
      this.search = '';
    },
  },
};
</script>

<style lang="scss">

</style>
